import { Select, SelectProps } from "antd";
import { BaseOptionType, DefaultOptionType } from "antd/es/select";

import { NotFoundComponent } from "./NotFoundComponent";

export type FormInputSelectProps<
  ValueType = unknown,
  OptionType extends BaseOptionType | DefaultOptionType = DefaultOptionType,
> = SelectProps<ValueType, OptionType> & {
  [key: `data-${string}`]: unknown;
};

export const FormInputSelect = <
  ValueType = unknown,
  OptionType extends BaseOptionType | DefaultOptionType = DefaultOptionType,
>({
  suffixIcon,
  optionFilterProp,
  ...props
}: FormInputSelectProps<ValueType, OptionType>) => {
  const notFoundContent: FormInputSelectProps["notFoundContent"] = (
    <NotFoundComponent loading={props.loading} />
  );

  return (
    <Select<ValueType, OptionType>
      allowClear
      options={[]}
      notFoundContent={notFoundContent}
      {...props}
      suffixIcon={!props.loading ? suffixIcon : undefined}
      optionFilterProp={optionFilterProp || props.fieldNames?.label || "label"}
    />
  );
};
